import { createAction } from '@reduxjs/toolkit';

export const lockAction = createAction('lock/lock');
export const unlockAction = createAction('lock/unlock');
